<template>
  <a-drawer
    ref="setJsonDialog"
    placement="right"
    :visible="isLimitDialogShow"
    width="800px"
    :mask-closable="false"
    wrap-class-name="set-json-drawer"
    @close="isLimitDialogShow=false"
  >
    <div
      slot="title"
      class="title"
    >
      <h2>
        推送数据格式
      </h2>
    </div>
    <div class="set-json-box">
      <div class="webhook-tip-d-t">
        <a-alert
          :message="tipTxt"
          type="info"
          show-icon
        />
      </div>
      <div ref="sendRecordRange">
        <send-record-range
          :range-data="itemData.range"
          @getRangeH="getRangeH"
        />
      </div>
      <div class="insert-btn-box">
        <a-popover
          v-model="ispopShow"
          placement="bottomRight"
          overlay-class-name="insert-var-popover"
        >
          <template slot="content">
            <div class="json-list-box">
              <div
                v-for="(item, index) in jsonDatas"
                :key="index + 'name'"
                class="json-item"
                :class="{'json-item-children':(item.child && item.child.length>0) }"
              >
                <template v-if="item.child && item.child.length>0">
                  <h2
                    class="tit"
                    :class="{'show-up': item.show}"
                    @click="showHide(item, index)"
                  >
                    <i
                      class="iconfont"
                      :class="item.show ? 'iconicon-test15' : 'iconicon-test14'"
                    />
                    {{ item.name }}
                  </h2>
                  <div
                    v-show="item.show"
                    class="json-con"
                  >
                    <div
                      v-for="(item2, index2) in item.child"
                      :key="item2.key"
                      class="var-item"
                      @mouseenter="showArgs(item2, index2)"
                      @mouseleave="showArgs(item2, index2)"
                    >
                      <span
                        class="var-item-tit"
                        @click="insertVar(item2)"
                      >
                        <em>{{ item2.name }}</em>
                        {{ item2.type }}
                      </span>
                      <template v-if="item2.tips && Object.keys(item2.tips).length > 0">
                        <div
                          v-show="item2.isArgShow"
                          class="args-list"
                        >
                          <ul :ref="`args${index2}`">
                            <li
                              v-for="(key, val) in item2.tips"
                              :key="key"
                            >
                              <span>{{ key }}: {{ val }}</span>
                            </li>
                          </ul>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
                <div
                  v-else
                  class="var-item"
                  @mouseenter="showArgs(item, index)"
                  @mouseleave="showArgs(item, index)"
                >
                  <span
                    class="var-item-tit"
                    @click="insertVar(item)"
                  >
                    <em>{{ item.name }}</em>
                    {{ item.type }}
                  </span>
                  <template v-if="item.tips && Object.keys(item.tips).length > 0">
                    <div
                      v-show="item.isArgShow"
                      class="args-list"
                    >
                      <ul :ref="`args${index}`">
                        <li
                          v-for="(key, val) in item.tips"
                          :key="key"
                        >
                          <span>{{ key }}: {{ val }}</span>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <a-button>
            {{ $t('message["84"]') }}
            <i class="iconfont iconicon-test69" />
          </a-button>
        </a-popover>
      </div>
      <div
        class="code-mirror-container"
        :style="`height: ${h}px;`"
      >
        <div
          class="code-mirror-box clearfix"
          :style="`height: ${h-2}px;`"
        >
          <div
            ref="codeMirror"
            class="code-mirror fl"
          >
            <codemirror
              ref="jsonEditor"
              v-model="jsonData"
              :options="options"
              :style="`{height: ${h-2}px;}`"
            />
          </div>
          <div class="operate-mirorr-btn">
            <a-popover placement="left">
              <template slot="content">
                <span>查找</span>
              </template>
              <span
                class="operate-mir-btn-item"
                @click="searchCode"
              ><i class="iconfont iconicon-test45" /></span>
            </a-popover>
            <a-popover placement="left">
              <template slot="content">
                <span>格式化</span>
              </template>
              <span
                class="operate-mir-btn-item"
                @click="formatCode"
              ><i class="iconfont icongeshihua" /></span>
            </a-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <a-button
        key="submit"
        :disabled="isValid"
        type="primary"
        @click="formHandle"
      >
        {{ $t('message["21"]') }}
      </a-button>
      <a-button
        :disabled="isValid "
        :loading="isTestValid"
        @click="testJsonData"
      >
        测试
      </a-button>
      <a-button
        key="back"
        @click="isLimitDialogShow=false"
      >
        {{ $t('message["896"]') }}
      </a-button>
    </div>
  </a-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { codemirror } from 'vue-codemirror'
import jsonlint from 'jsonlint'
import SendRecordRange from './SendRecordRange'

import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/selection/active-line'
import 'codemirror/mode/css/css'
import 'codemirror/theme/monokai.css'
import 'codemirror/keymap/sublime'

// 实现验证语法提示
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/lint/json-lint'
import 'codemirror/addon/display/autorefresh'

// 实现搜索
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/addon/search/jump-to-line.js'

import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'

// 折叠
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
window.jsonlint = jsonlint
export default {
  components: {
    codemirror,
    SendRecordRange
  },
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    },
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isLimitDialogShow: false,
      confirmLoading: false,
      jsonData: '{}',
      isValid: true,
      ispopShow: false,
      h: 400
    }
  },
  computed: {
    ...mapState('config/webhook', ['jsonDatas', 'isTestValid', 'sendRangeCheckedData', 'webhookDetail']),
    ...mapGetters('config/webhook', ['jsonDataList']),
    options: function () {
      return {
        mode: 'application/ld+json',
        tabSize: 2,
        lineNumbers: true,
        foldGutter: true,
        lineWrapping: true,
        theme: 'default',
        // viewportMargin: Infinity,
        extraKeys: { 'Ctrl-Space': 'autocomplete' },
        styleActiveLine: true,
        // highlightDifferences: true,
        keyMap: 'sublime',
        // smartIndent: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        lint: true,
        autoRefresh: true
      }
    },
    codemirror () {
      return this.$refs.jsonEditor.codemirror
    },
    tipTxt () {
      const { type = 1 } = this.webhookDetail
      const isVideo = type * 1 === 4
      return isVideo ? '请选择数据推送范围以及设置要推送的数据内容' : '请按照json格式设置要推送的数据'
    }
    // rangHeight () {
    //   return this.$refs.sendRecordRange ? this.$refs.sendRecordRange.offsetHeight + 24 : 0
    // }
  },
  watch: {
    isLimitDialogShow (b) {
      if (b) {
        this.getMember()
        this.setSendRangeCheckedData(this.itemData.range)
        this.$nextTick(() => {
          this.setMirrorHeight()
          this.codemirror.execCommand('clearSearch')
          this.jsonData = JSON.stringify(this.datas, null, 2)
          this.codemirror.setValue((JSON.stringify(JSON.parse(this.jsonData), null, 2)))
          this.getVars()
          window.addEventListener('resize', this.setMirrorHeight)
          document.addEventListener('scroll', this.setMirrorHeigh)
        })
      }
    },
    jsonData (val) {
      this.checkValid()
    }
  },
  methods: {
    ...mapActions('config/webhook', ['getVarData', 'getRangeTreeDatas']),
    ...mapMutations('config/webhook', ['setSendRangeCheckedData']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    // 插入变量
    insertVar (item) {
      const insertContent = this.webhookDetail.type === 4 ? `{{${item.name}}}` : `"{{${item.name}}}"`
      this.codemirror.replaceSelection(insertContent)
      this.ispopShow = false
    },
    // 搜索触发
    searchCode (e) {
      this.codemirror.execCommand('find')
    },
    // 检验是否通过验证
    checkValid () {
      setTimeout(() => {
        this.codemirror.refresh()
        const container = this.$refs.codeMirror
        const len = container.querySelectorAll('.CodeMirror-lint-marker-error').length
        this.isValid = !!len && len > 0
      }, 1000)
    },
    // 代码格式化
    formatCode () {
      this.codemirror.setValue((JSON.stringify(JSON.parse(this.jsonData), null, 2)))
    },
    // 提交
    async formHandle () {
      this.itemData.data = JSON.parse(this.jsonData)
      this.itemData.range = this.sendRangeCheckedData
      this.isLimitDialogShow = false
    },
    showHide (item, index) {
      const b = !item.show
      this.$set(item, 'show', b)
    },
    enterChange () {
      this.ispopShow = true
    },
    showArgs (item, index) {
      if (item.tips && Object.keys(item.tips).length > 0) {
        item.isArgShow = !item.isArgShow
        if (item.isArgShow) {
          setTimeout(() => {
            let arr = []
            const container = this.$refs[`args${index}`][0]
            const queryLis = container.querySelectorAll('li')
            queryLis.forEach(item => {
              const ele = item.querySelector('span')
              arr.push(ele.offsetWidth)
            })
            container.style.width = Math.max(...arr) + 32 + 'px'
          }, 10)
        }
      }
    },
    async getVars () {
      await this.getVarData({ type: this.itemData.type })
    },
    testJsonData () {
      this.$emit('validJson', this.itemData, JSON.parse(this.jsonData))
    },
    setMirrorHeight () {
      const rangHeight = this.$refs.sendRecordRange ? this.$refs.sendRecordRange.offsetHeight + 24 + 8 : 0
      this.h = document.body.clientHeight - 85 - 39 - 64 - 42 - rangHeight
      this.codemirror.setSize('100%', this.h - 2 + 'px')
    },
    async getMember () {
      const { type } = this.itemData
      const pk = type === 19 ? 'inquiry-dev' : 'inquiry-followup'
      const chain = await this.getRangeTreeDatas()
      chain.params({ pk, deal: 1 })
        .onSuccess(raw => {
          // this.$refs.sendRangeDialog.changeLimitDialog(true)
        })
        .fetch()
    },
    getRangeH () {
      this.$nextTick(() => {
        this.setMirrorHeight()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.webhook-tip-d-t::v-deep {
    margin: -16px 0 16px;
    .ant-alert-info{
      border-color:#4CA0F2 ;
      background: #DBEDFF;
    }
  }
  .insert-btn-box::v-deep {
    // text-align: right;
    margin-bottom: 10px;
    .ant-btn-default {
      margin-right: 0;
    }
    .iconicon-test69 {
      color: #ccc;
      margin-left: 6px;
    }
  }
.code-mirror-container {
  padding:6px 0 60px;
}

.code-mirror-box {
  border: 1px solid #ebebeb;
  // margin-top: 16px;
  overflow: hidden;
  .code-mirror {
    width: 654px;
    border-right: 1px solid #ebebeb;
    height: 100%;
  }
  .operate-mirorr-btn {
    width: 64px;
    float: right;
    text-align: center;
  padding-top: 24px;;
    .operate-mir-btn-item {
      width: 32px;
      height: 32px;
      display: block;
      margin: 0 auto 16px;
      border-radius: 4px;
      background: #ebebeb;
      line-height: 32px;
      cursor: pointer;
      i {
        color: #888;
      }
    }
  }
}
.json-list-box {
  max-height: 480px;
  overflow-y: auto;
  .json-item{
    display: inline-block;
    .tit {
      height: 32px;
      line-height: 32px;
      font-weight: bold;
      margin: 16px 0 8px;
      cursor: pointer;
      .iconfont {
        color: #d8d8d8;
        font-weight: normal;
        font-size: 14px;
      }
    }
    .show-up {
      i {
        transform:rotate(90deg);
        -ms-transform:rotate(90deg); /* Internet Explorer */
        -moz-transform:rotate(90deg); /* Firefox */
        -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
        -o-transform:rotate(90deg); /* Opera */
        }
      }
    }
    .var-item{
        margin: 0 16px 12px 0;
        position: relative;
        display: inline-block;
      .var-item-tit {
        cursor: pointer;
        border-radius: 4px;
        line-height: 20px;
        height: 20px;
        border: 1px solid #ebebeb;
        display: inline-block;
        color: #666;
        padding: 0 8px;
        font-weight: 400;
        font-size: 12px;
         em {
          border-right: 1px solid #ebebeb;
          display: inline-block;
          line-height: 18px;
          height: 18px;
          font-style: normal;
          margin-right: 1px;
          padding-right: 3px;
          font-weight: 500;
        }
      }
        .args-list {
          position: absolute;
          left: 0;
          top: 14px;
          right: 0;
          z-index: 10;
          padding-top: 10px;
          white-space:nowrap;
          ul {
            background:rgba(0,0,0,0.65);
            padding: 16px;
            line-height: 20px;
            color: #fff;
            border-radius: 4px;
            position: relative;
          }
          ul::after {
            position: absolute;
            content: "";
            height: 0;
            width: 0;
            border: 4px solid transparent;
            top: -8px;
            border-bottom-color: rgba(0,0,0,0.65);
            left: 41%;
          }
        }

      }
  }
  .json-item-children {
    display: block !important;
  }
</style>
<style lang="scss">
 .CodeMirror-lint-tooltip {
  z-index: 22222 !important;
  /* position: fixed !important; */
}
.set-json-drawer {
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 100%;
    padding: 16px 0 16px 80px;
    border-top: 1px solid $gray4;
    background: #fff;
  }
  .ant-drawer-close {
    top: 20px;
    right: 20px;
    .ant-drawer-close-x {
       width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 32px;
    color: #ccc;
    }
  }
  .ant-drawer-content-wrapper {
    height: auto;
  }
  .ant-drawer-content {
    padding: 0;
    border-bottom: none;
  }
  .ant-drawer-header {
    padding: 32px 40px;
    border-bottom: none;
  }
  .ant-drawer-title h2 {
    font-size: 32px;
    font-weight: 600;
  }
  .ant-drawer-body {
    padding: 0;
    height: 100%;
    .set-json-box {
      padding: 0 40px 64px;
      height: 100%;
    }
  }
}
.insert-var-popover {
  width: 436px;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner-content {
    padding: 16px 4px 16px 16px;
  }
}
</style>
